import { TrackEventRequest, platformApiApi } from "@capone/platform-api";
import { config } from "../config";

import { mcLeanAxiosInstance } from "../../components/AxiosInterceptors";
import { getGlobalTrackingProperties } from "@capone/common";
import { store } from "../../app/store";

export const trackEvent = (req: TrackEventRequest): Promise<boolean> =>
  new Promise(async (resolve, reject) => {
    req.properties = {
      ...req.properties,
      ...getGlobalTrackingProperties(
        config.TENANT,
        store.getState().rootReducer
      ),
      has_travel_credit: req.properties.has_credits,
    };
    try {
      const res = await platformApiApi(mcLeanAxiosInstance).apiV0TrackingEventPost(
        req,
        { baseURL: config.baseURL }
      );

      resolve(res.data.Response === "Success");
    } catch (e) {
      console.error(e);
      reject(e);
    }
  });
